export const releaseDates = [
  { id: 0, value: [2020, new Date().getFullYear()], title: 'Recent 2020s' },
  { id: 1, value: [2000, 2010], title: 'Rise of Streaming 2010s' },
  { id: 2, value: [1990, 2000], title: 'Modern Classics 90s-2000s' },
  { id: 3, value: [1970, 1980], title: 'Influential Movies 70s-80s' },
  { id: 4, value: [1920, 1960], title: 'Classic Hollywood 20s-60s' },
  { id: 5, value: [1890, 1920], title: 'Silent Films 1890s-1920s' }
]
export const keywords = [
  { value: 818, title: 'based on book' },
  { value: 9717, title: 'based on comic' },
  { value: 34117, title: 'cult film' },
  { value: 156866, title: 'based on short story' },
  { value: 10181, title: 'based on musical' },
  { value: 158718, title: 'lgbt' },
  { value: 9672, title: 'based on true story' },
  { value: 10683, title: 'coming of age' },
  { value: 4344, title: 'musical' },
  { value: 3691, title: 'forbidden love' },
  { value: 11322, title: 'female protagonist' },
  { value: 4565, title: 'dystopia' },
  { value: 207317, title: 'christmas' },
  { value: 276130, title: 'paranormal events' },
  { value: 9715, title: 'superhero' },
  { value: 282, title: 'video game' },
  { value: 10714, title: 'serial killer' },
  { value: 210024, title: 'anime' },
  { value: 2964, title: 'future' },
  { value: 83, title: 'saving the world' },
  { value: 14602, title: 'break-up' },
  { value: 6956, title: 'treasure hunt' }
]